import { useHits } from "react-instantsearch";
import BlogCard from "@/components/Blog/BlogCard";
import type { BlogPost } from "@/types/search";

function BlogSearchFeaturedResults({
  onTagClick,
}: {
  onTagClick?: (tag: string) => void;
}) {
  const { hits } = useHits<BlogPost>();

  return (
    <div className="grid grid-cols-1">
      {hits.map((post, index) => (
        <BlogCard
          key={`featured:${post.uid}`}
          size="medium"
          title={post.title}
          image={post.image}
          pubDate={post.last_publication_date}
          tags={post.tag}
          link={post.url}
          priority={index === 0}
          onTagClick={onTagClick}
        />
      ))}
    </div>
  );
}

export default BlogSearchFeaturedResults;
